<script setup lang="ts">
import { onMounted } from 'vue';
const { locale, t } = useI18n()
const dayjs = useDayjs()

if (locale.value == 'dk') {
  dayjs.locale('da')
} else {
  dayjs.locale(locale.value)
}

watch(locale, () => {
  if (locale.value == 'dk') {
    dayjs.locale('da')
  } else {
    dayjs.locale(locale.value)
  }
});

useHead({
  meta: [
    { charset: 'utf-8' },
  ],
  link: [
    { rel: 'icon', href: '/favicon.ico' },
    { rel: 'manifest', href: '/manifest.json' },
  ],
  htmlAttrs: {
    lang: computed(() => locale.value === 'dk' ? 'da' : locale.value)
  },
  script: [],
})

const title = computed(() => t('seo.app.title'))
const description = computed(() => t('seo.app.description'))

// Pull-to-refresh functionality for PWA
const refreshPage = async () => {
  // Refresh the current page
  await refreshCookie()
  window.location.reload()
}

const { isRefreshing, pullDistance, isPulling, mount, unmount } = usePullToRefresh(refreshPage)

onMounted(async () => {
  const nuxtApp = useNuxtApp()
  
  // Mount pull-to-refresh listeners
  mount()
})

onBeforeUnmount(() => {
  // Clean up pull-to-refresh listeners
  unmount()
})

// Global SEO fallback configuration
useSeoMeta({
  title: title,
  description: description,
  ogTitle: title,
  ogDescription: description,
  ogImage: 'https://shiftgo.dk/social-card.png',
  twitterCard: 'summary_large_image',
  twitterTitle: title,
  twitterDescription: description,
  twitterImage: 'https://shiftgo.dk/social-card.png',
  appleMobileWebAppTitle: 'ShiftGo',
  applicationName: 'ShiftGo',
  themeColor: '#3b82f6'
})
</script>

<template>
  <div class="min-h-screen flex flex-col justify-between">
    <!-- Pull-to-refresh indicator -->
    <div 
      v-if="isPulling || isRefreshing"
      class="fixed top-0 left-0 right-0 z-50 flex justify-center items-center transition-transform duration-300"
      :style="{ 
        transform: `translateY(${isPulling ? pullDistance - 60 : isRefreshing ? 20 : -60}px)`,
        opacity: isPulling || isRefreshing ? 1 : 0
      }"
    >
      <div class="bg-white dark:bg-gray-800 rounded-full shadow-lg p-3 border border-gray-200 dark:border-gray-700">
        <UIcon 
          :name="isRefreshing ? 'i-heroicons-arrow-path' : 'i-heroicons-arrow-down'"
          :class="[
            'w-6 h-6 text-primary-500',
            isRefreshing ? 'animate-spin' : pullDistance > 80 ? 'rotate-180' : ''
          ]"
        />
      </div>
    </div>
    <NuxtLoadingIndicator />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <UNotifications />
    <UModals />
  </div>
</template>
